export const API_GET_LOADING = 'api/get/loading';
export const API_GET_SUCCESS = 'api/get/success';
export const API_GET_ERROR = 'api/get/error';

export const Update_Data = 'update/data';

// export const API_UPDATE_LOADING = 'api/update/loading';
// export const API_UPDATE_SUCCESS = 'api/update/success';
// export const API_UPDATE_ERROR = 'api/update/error';

// export const API_DELETE = 'api/delete';

// export const API_ADD = 'api/add';

